import axios from "axios";
export var fetchPolizaFiles = function fetchPolizaFiles(poliza_id) {
  return axios.get("/api/v1/poliza_files/", {
    params: {
      poliza_id: poliza_id
    },
    timeout: 5000 // 5 segundos timeout

  }).then(function (response) {
    return response.data;
  })["catch"](function (error) {
    // Si es un error 500 o timeout, retornar array vacío para que no bloquee la UI
    if (error.code === 'ECONNABORTED' || error.response && error.response.status === 500) {
      return {
        poliza_files: []
      };
    }

    throw error;
  });
};

var buildPolizaFileFormData = function buildPolizaFileFormData(poliza_file) {
  var formData = new FormData();
  formData.append("poliza_file[poliza_id]", poliza_file.poliza_id.toString());
  formData.append("poliza_file[file_type]", poliza_file.file_type);

  if (poliza_file.file instanceof File) {
    formData.append("poliza_file[file]", poliza_file.file);
  } else if (poliza_file.file_cache) {
    formData.append("poliza_file[file_cache]", poliza_file.file_cache);
  }

  return formData;
};

export var createPolizaFile = function createPolizaFile(poliza_file, token) {
  var formData = buildPolizaFileFormData(poliza_file);
  var headers = {
    "Content-Type": "multipart/form-data",
    "Accept": "application/json"
  };

  if (token) {
    headers["X-CSRF-Token"] = token;
  } else {
    // Obtener token del meta tag si no se proporciona
    var metaToken = document.querySelector('meta[name="csrf-token"]');

    if (metaToken) {
      headers["X-CSRF-Token"] = metaToken.getAttribute("content");
    }
  }

  return axios.post("/api/v1/poliza_files", formData, {
    headers: headers
  });
};
export var updatePolizaFile = function updatePolizaFile(poliza_file, token) {
  var formData = new FormData(); // Solo enviar file_type si está definido (undefined = no actualizar)
  // Si es null o string vacío, enviar como string vacío (limpiar el campo)

  if (poliza_file.file_type !== undefined) {
    formData.append("poliza_file[file_type]", poliza_file.file_type || "");
  } // Solo enviar archivo si se está actualizando


  if (poliza_file.file instanceof File) {
    formData.append("poliza_file[file]", poliza_file.file);
  } else if (poliza_file.file_cache) {
    formData.append("poliza_file[file_cache]", poliza_file.file_cache);
  }

  var headers = {
    "Content-Type": "multipart/form-data",
    "Accept": "application/json"
  };

  if (token) {
    headers["X-CSRF-Token"] = token;
  } else {
    // Obtener token del meta tag si no se proporciona
    var metaToken = document.querySelector('meta[name="csrf-token"]');

    if (metaToken) {
      headers["X-CSRF-Token"] = metaToken.getAttribute("content");
    }
  }

  return axios.put("/api/v1/poliza_files/".concat(poliza_file.id), formData, {
    headers: headers
  });
};
export var deletePolizaFile = function deletePolizaFile(id, token) {
  var headers = {
    "Accept": "application/json"
  };

  if (token) {
    headers["X-CSRF-Token"] = token;
  } else {
    // Obtener token del meta tag si no se proporciona
    var metaToken = document.querySelector('meta[name="csrf-token"]');

    if (metaToken) {
      headers["X-CSRF-Token"] = metaToken.getAttribute("content");
    }
  }

  return axios["delete"]("/api/v1/poliza_files/".concat(id), {
    headers: headers
  });
};
export var fetchPolizaFile = function fetchPolizaFile(id) {
  return axios.get("/api/v1/poliza_files/".concat(id), {
    timeout: 5000
  }).then(function (response) {
    return response.data;
  })["catch"](function (error) {
    if (error.code === 'ECONNABORTED' || error.response && error.response.status === 500) {
      throw new Error("Error al obtener el archivo");
    }

    throw error;
  });
};
export var getIndexQueryKey = function getIndexQueryKey(poliza_id) {
  return ["/api/v1/poliza_files/".concat(poliza_id)];
};